import React from 'react';
import { withRouter } from 'react-router-dom'


class Summary extends React.Component {
  
  constructor(props) {
    super(props)
    this.state = {
      isShowingMessage: false,
    };
    
  }
  
  componentDidUpdate(prevProps, prevState) {
    var self = this;
    
    if (!prevProps.isActive && this.props.isActive) {
      setTimeout(function() {
        self.setState({isShowingMessage: true});
      }, 2500);
    }
    
  }
  
  componentDidMount() {
//     var self = this;
  }
  
  
  render() {
    
    const { isActive } = this.props;
    
    var self = this,
        wrapperClasses = ['photo-journey__content__section'];
    
    if(isActive) {
      wrapperClasses.push('photo-journey__content__section--active');
    }
    
    return (
      
      <div className={wrapperClasses.join(' ')}>
        
        <div className="photo-journey__content__section__full-width">
          
          <div className="photo-summary">
            <div className="photo-summary__diagram">
              
              <div className="photo-summary__diagram__body">
                
                <div className="photo-summary__diagram__device photo-summary__diagram__device--phone-suzi"></div>
                
                {this.props.shareChain.map((person, index) => {
                  var classes = ['photo-summary__diagram__device', 'photo-summary__diagram__device--'+person.device, 'photo-summary__diagram__device--index-'+index];
                  return (
                    <div key={index} className={classes.join(' ')}>
                      <div className={'person-profile person-profile--person'+person.id}></div>
                    </div>
                  )
                  
                })}

                <div className="photo-summary__diagram__photo-circle"></div>
              </div>

            </div>
            <h1>See how a photo can be shared with so many people using different devices.<br/>You should always ask somebody’s permission before taking and sharing their photo.</h1>
            <p>
            {this.props.shareChain.map((person, index) => {
                if(index === 0){
                  return (
                    <span key={index}>{'You shared the photo with '+person.name+' from your smartphone to '+person.pronouns[1]+' '+person.deviceLabel+'.'}<br/></span>
                  )
                }else{
                  return (
                    <span key={index}>{this.props.shareChain[index-1].name+' shares the photo with '+person.name+' from '+this.props.shareChain[index-1].pronouns[1]+' '+this.props.shareChain[index-1].deviceLabel+' to '+person.pronouns[1]+' '+person.deviceLabel+'.'}<br/></span>
                  )
                }
              })}
              {this.props.shareChain[this.props.shareChain.length - 1] ?
              //this.props.shareChain[this.props.shareChain.length - 1].deviceLabel
              <span>{'They share the photo with all their friends from their '+this.props.shareChain[this.props.shareChain.length - 1].deviceLabel+' to their social network.'}<br/></span>
              : null}
              <span>Your parent/carer sees the photo and you see it again on their computer.<br/></span></p>
            <div className="photo-summary__buttons">
              <button onClick={self.props.onSelectFinish} className="button button--wide button--wide--tick hide-print"><span>Finish</span></button>
              <button onClick={(e) => self.props.onPrint()} type="submit" className="button button--wide button--wide--print"><span>{self.props.printingStatus? 'Printing...' : 'Print'}</span></button>
            </div>
            
          </div>

        </div>
                
      </div>
      
    )
  }
};


export default withRouter(Summary);